import { Action } from '@ngrx/store';
import { Inventory } from './inventory.model';

export const GET_INVENTORY = 'GET_INVENTORY';

export class GetInventory implements Action {
    readonly type = GET_INVENTORY;

    constructor(public payload: Inventory) { }
}

export type InventoryActions = GetInventory;
